export default __webpack_public_path__ + "static/combineSectionBg-7af4d32d8885cda269b0236610128cff.png";